import React from "react";
import { IconClose, IconRightArrow2, LogoRefabric } from "icons";
import TryForFree from "components/TryForFree";
import Button from "components/Button";
import { useNavigate } from "react-router-dom";
import { PATHS } from "router/config/paths";
import { AnalyticsEvent } from "utils";
import { buildAppUrl } from "utils/buildAppUrl";
import { DOCS_URL } from "utils/constants";
import clsx from "clsx";
import { ImageAIFabric_3, ImageAIFabric_4, ImageAP_OnBody1, ImageAP_OnBody2, ImageTPSlider1, ImageTPSlider2 } from "images";
import BeforeAfterImage from "pages/FeaturesPage/components/BeforeAfterImage";
import "pages/FeaturesPage/components/DesignTools.css";

const body = document.querySelector("body");

const MobileHeaderMenu = ({ show, headerItems, onClose }: any) => {
  const navigate = useNavigate();
  const [showFeaturesMenu, setShowFeaturesMenu] = React.useState(false);
  const [showResourcesMenu, setShowResourcesMenu] = React.useState(false);

  React.useEffect(() => {
    if (show && body) {
      body.style.overflow = "hidden";
    }

    return () => {
      if (body) body.style.overflow = "auto";
    };
  }, [show]);

  return (
    <div className="fixed h-screen w-screen bg-white z-[60]">
      <div className="flex flex-col fixed top-0 left-0 w-full z-[61] bg-white h-full overflow-y-auto">
        <div className="flex items-center justify-between p-5 border-b border-grey-light">
          <LogoRefabric
            className="cursor-pointer"
            onClick={() => {
              AnalyticsEvent("header_mobile_refabric_logo", "", "click");
              navigate(PATHS.HOME + window.location.search);
              onClose();
            }}
          />
          <IconClose className="cursor-pointer w-6 h-6 flex-shrink-0" onClick={onClose} />
        </div>
        <div className="flex flex-col">
          {/* Features */}
          <div className={clsx("flex flex-col items-center justify-between p-5", showFeaturesMenu ? "pb-0" : "")} onClick={() => setShowFeaturesMenu(!showFeaturesMenu)}>
            <div className="flex justify-between w-full items-center">
              <a className="text-h7-satoshi !text-[20px] !leading-[100%]">Features</a>
              <IconRightArrow2 className={clsx(showFeaturesMenu ? "-rotate-90" : "rotate-90")} />
            </div>
            {showFeaturesMenu && (
              <div className="flex flex-col w-full gap-10 py-5 border-b border-grey-light">
                <div
                  className="flex gap-5 items-center w-full"
                  onClick={(e) => {
                    e.stopPropagation();
                    AnalyticsEvent("header_features", "", "click");
                    navigate(PATHS.FEATURES + window.location.search);
                    setShowFeaturesMenu(false);
                    onClose();
                  }}
                >
                  <div className="w-[112px] shrink-0 aspect-square overflow-hidden rounded-md">
                    <BeforeAfterImage fill sliderPercentPosition={50} mainImage={ImageAIFabric_4} images={[ImageAIFabric_3]} />
                  </div>
                  <div className="flex flex-col gap-3">
                    <span className="text-h7-satoshi !text-[20px] text-black">AI Design</span>
                    <span className="text-bodyLg text-black">Design faster and smarter with AI, from first idea to final look.</span>
                  </div>
                </div>
                <div
                  className="flex gap-5 items-center w-full"
                  onClick={(e) => {
                    e.stopPropagation();
                    AnalyticsEvent("header_ai_photoshoot", "", "click");
                    navigate(PATHS.AI_PHOTOSHOOT + window.location.search);
                    setShowFeaturesMenu(false);
                    onClose();
                  }}
                >
                  <div className="w-[112px] shrink-0 aspect-square overflow-hidden rounded-md">
                    <BeforeAfterImage fill sliderPercentPosition={50} mainImage={ImageAP_OnBody1} images={[ImageAP_OnBody2]} />
                  </div>
                  <div className="flex flex-col gap-3">
                    <span className="text-h7-satoshi !text-[20px] text-black">AI Photoshoot</span>
                    <span className="text-bodyLg text-black">Create e-commerce-ready visuals without a studio, samples, or models.</span>
                  </div>
                </div>
                <div
                  className="flex gap-5 items-center w-full"
                  onClick={(e) => {
                    e.stopPropagation();
                    AnalyticsEvent("header_tech_packs", "", "click");
                    navigate(PATHS.TECH_PACKS + window.location.search);
                    setShowFeaturesMenu(false);
                    onClose();
                  }}
                >
                  <div className="w-[112px] shrink-0 aspect-square overflow-hidden rounded-md">
                    <BeforeAfterImage fill sliderPercentPosition={50} mainImage={ImageTPSlider1} images={[ImageTPSlider2]} />
                  </div>
                  <div className="flex flex-col gap-3">
                    <span className="text-h7-satoshi !text-[20px] text-black">AI Tech Packs</span>
                    <span className="text-bodyLg text-black">Upload a product image and receive a production-ready tech pack in minutes.</span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Pricing */}
          <div
            className="flex flex-col items-center justify-between p-5"
            onClick={() => {
              AnalyticsEvent("header_pricing", "", "click");
              navigate(PATHS.PRICING + window.location.search);
              onClose();
            }}
          >
            <div className="flex justify-between w-full items-center">
              <a className="text-h7-satoshi !text-[20px] !leading-[100%]">Pricing</a>
              <IconRightArrow2 />
            </div>
          </div>

          {/* Docs */}
          <div
            className="flex flex-col items-center justify-between p-5"
            onClick={() => {
              AnalyticsEvent("header_docs", "", "click");
              window.open(DOCS_URL, "_blank", "noopener,noreferrer");
              onClose();
            }}
          >
            <div className="flex justify-between w-full items-center">
              <a className="text-h7-satoshi !text-[20px] !leading-[100%]">Docs</a>
              <IconRightArrow2 />
            </div>
          </div>

          {/* Resources */}
          <div className={clsx("flex flex-col items-center justify-between p-5", showResourcesMenu ? "pb-0" : "")} onClick={() => setShowResourcesMenu(!showResourcesMenu)}>
            <div className="flex justify-between w-full items-center">
              <a className="text-h7-satoshi !text-[20px] !leading-[100%]">Resources</a>
              <IconRightArrow2 className={clsx(showResourcesMenu ? "-rotate-90" : "rotate-90")} />
            </div>
            {showResourcesMenu && (
              <div className="flex flex-col w-full gap-10 py-5 border-b border-grey-light">
                <div
                  className="flex gap-5 items-center w-full"
                  onClick={(e) => {
                    e.stopPropagation();
                    AnalyticsEvent("header_ambassadors", "", "click");
                    navigate(PATHS.AMBASSADORS + window.location.search);
                    setShowResourcesMenu(false);
                    onClose();
                  }}
                >
                  <div className="flex flex-col gap-3">
                    <span className="text-h7-satoshi !text-[20px] text-black">Ambassadors</span>
                    <span className="text-bodyLg text-black">Guide and inspire new Refabric designers, get awarded.</span>
                  </div>
                </div>
                <div
                  className="flex gap-5 items-center w-full"
                  onClick={(e) => {
                    e.stopPropagation();
                    AnalyticsEvent("header_about", "", "click");
                    navigate(PATHS.ABOUT + window.location.search);
                    setShowResourcesMenu(false);
                    onClose();
                  }}
                >
                  <div className="flex flex-col gap-3">
                    <span className="text-h7-satoshi !text-[20px] text-black">About</span>
                    <span className="text-bodyLg text-black">Push the boundaries of creativity with AI-powered fashion design.</span>
                  </div>
                </div>
                <div
                  className="flex gap-5 items-center w-full"
                  onClick={(e) => {
                    e.stopPropagation();
                    AnalyticsEvent("header_academy", "", "click");
                    navigate(PATHS.ACADEMY + window.location.search);
                    setShowResourcesMenu(false);
                    onClose();
                  }}
                >
                  <div className="flex flex-col gap-3">
                    <span className="text-h7-satoshi !text-[20px] text-black">Academy</span>
                    <span className="text-bodyLg text-black">Browse our library of AI fashion courses and tutorials.</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-col p-5 gap-3">
          <a
            href={buildAppUrl("/signup")}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              AnalyticsEvent("header_mobile_signin", "", "click");
            }}
          >
            <Button className="btn-secondary btn-sm whitespace-nowrap w-full">Sign In</Button>
          </a>
          <TryForFree
            btnClassName="btn-primary btn-sm w-full"
            containerClassName="w-full"
            callback={() => {
              AnalyticsEvent("header_mobile_tryforfree", "", "click");
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default MobileHeaderMenu;
